module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-embed": "static-1.26458",
      "conversations-internal-schema": "static-1.12749",
      "head-dlb": "static-1.4938",
      "hs-test-utils": "static-1.7950",
      "hubspot-url-utils": "static-1.4083",
      "HubStyleTokens": "static-2.11397",
      "I18n": "static-7.1610",
      "jasmine-runner": "static-1.6406",
      "quartz": "static-1.6930",
      "react": "static-7.184",
      "sinon": "static-1.9",
      "StyleGuideUI": "static-3.485",
      "webpack-env": "static-1.54",
      "visitor-ui-component-library": "static-1.6074",
      "enviro": "static-4.428",
      "hs-promise-rejection-tracking": "static-1.5489",
      "PortalIdParser": "static-2.388",
      "raven": "static-3.5829",
      "raven-hubspot": "static-1.6136",
      "bend-plugin-trellis-migration": "static-1.3355",
      "moment": "static-3.26",
      "customer-data-email": "static-1.17916",
      "cv-backend-services": "static-1.1551",
      "hub-http": "static-1.6158",
      "immutable": "static-2.78",
      "immutable-less": "static-1.4588",
      "quartz-config": "static-1.708",
      "quartz-core": "static-1.6149",
      "transmute": "static-2.85",
      "HeadJS": "static-2.740",
      "react-dom": "static-7.85",
      "foundations-components": "static-1.7802",
      "framer-motion": "static-1.70",
      "hs-test-utils-bend-plugin": "static-1.3061",
      "msw": "static-1.39",
      "react-redux": "static-7.70",
      "redux": "static-4.16",
      "testing-library": "static-1.150",
      "foundations-theming": "static-1.4352",
      "i18n-data": "static-1.219",
      "metrics-js": "static-1.9579",
      "moment-timezone": "static-5.81",
      "react-utils": "static-2.5295",
      "jasmine": "static-4.4261",
      "csstype": "static-1.50",
      "hoist-non-react-statics": "static-3.9",
      "PatternValidationJS": "static-1.437",
      "react-aria": "static-1.64",
      "styled-components": "static-2.88",
      "UIComponents": "static-3.8344",
      "visitor-ui-component-library-icons": "static-1.5885",
      "bender-build-tools": "static-1.3093",
      "apollo-dlb": "static-3.86",
      "apollo-link-hub-http": "static-2.4587",
      "apollo-stack-hubspot": "static-3.84",
      "classnames": "static-2.10",
      "cssUtils": "static-1.778",
      "customer-data-objects": "static-1.7598",
      "customer-data-ui-utilities": "static-1.9763",
      "data-fetching-client": "static-1.9611",
      "FileManagerCore": "static-1.38920",
      "FileManagerLib": "static-1.39061",
      "foundations-assets": "static-1.4789",
      "graphql": "static-1.80",
      "hs-promise-utils": "static-1.5531",
      "hubspot-apollo-client": "static-1.4815",
      "icons": "static-2.643",
      "react-immutable-proptypes": "static-2.8",
      "react-immutable-render-mixin": "static-1.9",
      "react-input-autosize": "static-2.17",
      "react-select-plus": "static-1.103",
      "react-virtualized": "static-2.97",
      "rpc-client-utils": "static-1.4582",
      "salesImages": "static-1.523",
      "timezone-utils": "static-2.5180",
      "ui-gdpr-components": "static-1.10284",
      "ts-schema": "static-1.4029",
      "hs-locale-management": "static-1.35",
      "hs-lodash": "static-4.45",
      "immer": "static-1.33",
      "dispatcher": "static-1.135",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.826",
      "hubspotter-http": "static-1.4603",
      "mobile-manifest-mixins": "static-1.514",
      "module-federation": "static-1.21",
      "quartz-auth": "static-1.605",
      "quartz-head": "static-1.595",
      "quartz-i18n": "static-1.605",
      "quartz-routing": "static-1.360",
      "quartz-test": "static-1.605",
      "quartz-tracking": "static-1.309",
      "quick-fetch": "static-1.3868",
      "react-rhumb": "static-1.16597",
      "ui-fonts": "static-1.659",
      "usage-tracker-container": "static-1.7263",
      "usage-tracker-core": "static-1.7123",
      "bend-plugin-foundations-components": "static-1.4071",
      "floating-ui": "static-1.54",
      "foundations-theming-specialty": "static-1.2068",
      "hs-story-utils": "static-1.9366",
      "tanstack-table": "static-1.53",
      "trellis-assets": "static-1.1622",
      "ui-images": "static-2.1138",
      "bend-plugin-foundations-theming": "static-1.2835",
      "foundations-theming-base": "static-1.3337",
      "stylex": "static-1.31",
      "HubStyle": "static-2.11705",
      "sassPrefix": "static-1.154",
      "inbound-db-properties-service-client": "static-1.3793",
      "property-translator": "static-1.5339",
      "react-dnd-compat": "static-1.4556",
      "fast-json-stable-stringify": "static-1.4",
      "ai-components-ui-library": "static-1.8770",
      "audio-components": "static-1.5814",
      "cropperjs": "static-1.10",
      "feedback-loader": "static-1.29177",
      "file-manager-components": "static-1.23421",
      "FileManagerImages": "static-1.36572",
      "foundations-components-legacy": "static-1.827",
      "immerable": "static-1.4090",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "ui-universal-auth": "static-1.8894",
      "urlinator": "static-1.4468",
      "video-components": "static-1.13051",
      "video-data-lib": "static-1.34706",
      "video-embed": "static-1.35540",
      "redux-thunk": "static-2.43",
      "hubspot-apollo-cache": "static-1.274",
      "chirp-fetch": "static-1.1820",
      "hub-http-shared-msw-handlers": "static-1.9810",
      "hubspotter-http-shared-msw-handlers": "static-1.9808",
      "history": "static-4.47",
      "react-router-dom": "static-5.26",
      "usage-tracker-session-replay": "static-1.4959",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "autolinker": "static-3.11",
      "chatspot-core": "static-1.20970",
      "ContentUtils": "static-1.68158",
      "copilot-toolkit": "static-1.10944",
      "sanitize": "static-1.4409",
      "sanitize-text": "static-1.8081",
      "content-assistance-lib": "static-1.7650",
      "usage-tracker": "static-1.7273",
      "ui-addon-iframeable": "static-1.8989",
      "video-components-external": "static-1.11048",
      "unified-auth-core-lib": "static-1.689",
      "content-icons-ui": "static-1.2211",
      "social-insights-client-types": "static-1.21881",
      "SharedI18nStrings": "static-1.182",
      "outpost": "static-1.4126",
      "amplitude-session-replay-browser": "static-1.58",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4747",
      "integrations-lib": "static-1.15893",
      "underscore": "static-1.8",
      "magpie-lib": "static-1.5519",
      "magpie-types": "static-1.4979",
      "simple-logging-lib": "static-1.2987",
      "superstore": "static-1.4705",
      "ui-addon-video-player": "static-1.8634",
      "ui-coaching-tips": "static-1.28352",
      "navigation-messaging": "static-1.7127",
      "content-media-composition-data-lib": "static-1.12027",
      "content-media-compositions": "static-2.16034",
      "idb-keyval": "static-1.42",
      "media-bridge-lib": "static-1.18810",
      "fsm": "static-1.3671",
      "flux-actions": "static-1.329",
      "frontend-preferences-client": "static-1.7863",
      "integrations-error-boundary-lib": "static-1.13308",
      "integrations-tracking-lib": "static-1.5534",
      "laboratory-lib": "static-3.7095",
      "native-integrations-shared-strings": "static-1.7722",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.10310",
      "rxjs": "static-5.10",
      "ui-addon-i18n": "static-1.11087",
      "ui-shepherd-react": "static-3.10085",
      "unified-auth": "static-1.408",
      "reactive-lib": "static-1.659",
      "growth-onboarding-feedback-components": "static-1.6520",
      "js-cookie": "static-1.18",
      "universal-page-editor-lib": "static-1.2946",
      "foundations-components-test-utils": "static-1.5285",
      "google-sheets-integration-lib": "static-1.36",
      "microsoft-drive-integration-lib": "static-1.136",
      "react-dlb": "static-1.77",
      "crm-record-cards-service-types": "static-1.3562",
      "framework-data-schema-resolvers": "static-1.6813",
      "location-customization-utils-lib": "static-1.9035",
      "batch-promise": "static-1.1489",
      "conditional-properties-service-client": "static-1.3748",
      "crm-pipelines-api-client-types": "static-1.4094",
      "framework-builder-read-service-client": "static-1.3961",
      "framework-data-schema-quick-fetch": "static-1.6718",
      "inbound-db-meta-service-client": "static-1.3542",
      "multi-currency-client-types": "static-1.3643",
      "persist-promise": "static-1.3646"
    },
    "depPathPrefixes": {
      "conversations-embed": "/conversations-embed/static-1.26458",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12749",
      "head-dlb": "/head-dlb/static-1.4938",
      "hs-test-utils": "/hs-test-utils/static-1.7950",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.4083",
      "HubStyleTokens": "/HubStyleTokens/static-2.11397",
      "I18n": "/I18n/static-7.1610",
      "jasmine-runner": "/jasmine-runner/static-1.6406",
      "quartz": "/quartz/static-1.6930",
      "react": "/react/static-7.184",
      "sinon": "/sinon/static-1.9",
      "StyleGuideUI": "/StyleGuideUI/static-3.485",
      "webpack-env": "/webpack-env/static-1.54",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.6074",
      "enviro": "/enviro/static-4.428",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
      "PortalIdParser": "/PortalIdParser/static-2.388",
      "raven": "/raven/static-3.5829",
      "raven-hubspot": "/raven-hubspot/static-1.6136",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3355",
      "moment": "/moment/static-3.26",
      "customer-data-email": "/customer-data-email/static-1.17916",
      "cv-backend-services": "/cv-backend-services/static-1.1551",
      "hub-http": "/hub-http/static-1.6158",
      "immutable": "/immutable/static-2.78",
      "immutable-less": "/immutable-less/static-1.4588",
      "quartz-config": "/quartz-config/static-1.708",
      "quartz-core": "/quartz-core/static-1.6149",
      "transmute": "/transmute/static-2.85",
      "HeadJS": "/HeadJS/static-2.740",
      "react-dom": "/react-dom/static-7.85",
      "foundations-components": "/foundations-components/static-1.7802",
      "framer-motion": "/framer-motion/static-1.70",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3061",
      "msw": "/msw/static-1.39",
      "react-redux": "/react-redux/static-7.70",
      "redux": "/redux/static-4.16",
      "testing-library": "/testing-library/static-1.150",
      "foundations-theming": "/foundations-theming/static-1.4352",
      "i18n-data": "/i18n-data/static-1.219",
      "metrics-js": "/metrics-js/static-1.9579",
      "moment-timezone": "/moment-timezone/static-5.81",
      "react-utils": "/react-utils/static-2.5295",
      "jasmine": "/jasmine/static-4.4261",
      "csstype": "/csstype/static-1.50",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "react-aria": "/react-aria/static-1.64",
      "styled-components": "/styled-components/static-2.88",
      "UIComponents": "/UIComponents/static-3.8344",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5885",
      "bender-build-tools": "/bender-build-tools/static-1.3093",
      "apollo-dlb": "/apollo-dlb/static-3.86",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4587",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
      "classnames": "/classnames/static-2.10",
      "cssUtils": "/cssUtils/static-1.778",
      "customer-data-objects": "/customer-data-objects/static-1.7598",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9763",
      "data-fetching-client": "/data-fetching-client/static-1.9611",
      "FileManagerCore": "/FileManagerCore/static-1.38920",
      "FileManagerLib": "/FileManagerLib/static-1.39061",
      "foundations-assets": "/foundations-assets/static-1.4789",
      "graphql": "/graphql/static-1.80",
      "hs-promise-utils": "/hs-promise-utils/static-1.5531",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4815",
      "icons": "/icons/static-2.643",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-select-plus": "/react-select-plus/static-1.103",
      "react-virtualized": "/react-virtualized/static-2.97",
      "rpc-client-utils": "/rpc-client-utils/static-1.4582",
      "salesImages": "/salesImages/static-1.523",
      "timezone-utils": "/timezone-utils/static-2.5180",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10284",
      "ts-schema": "/ts-schema/static-1.4029",
      "hs-locale-management": "/hs-locale-management/static-1.35",
      "hs-lodash": "/hs-lodash/static-4.45",
      "immer": "/immer/static-1.33",
      "dispatcher": "/dispatcher/static-1.135",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.826",
      "hubspotter-http": "/hubspotter-http/static-1.4603",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.514",
      "module-federation": "/module-federation/static-1.21",
      "quartz-auth": "/quartz-auth/static-1.605",
      "quartz-head": "/quartz-head/static-1.595",
      "quartz-i18n": "/quartz-i18n/static-1.605",
      "quartz-routing": "/quartz-routing/static-1.360",
      "quartz-test": "/quartz-test/static-1.605",
      "quartz-tracking": "/quartz-tracking/static-1.309",
      "quick-fetch": "/quick-fetch/static-1.3868",
      "react-rhumb": "/react-rhumb/static-1.16597",
      "ui-fonts": "/ui-fonts/static-1.659",
      "usage-tracker-container": "/usage-tracker-container/static-1.7263",
      "usage-tracker-core": "/usage-tracker-core/static-1.7123",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4071",
      "floating-ui": "/floating-ui/static-1.54",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2068",
      "hs-story-utils": "/hs-story-utils/static-1.9366",
      "tanstack-table": "/tanstack-table/static-1.53",
      "trellis-assets": "/trellis-assets/static-1.1622",
      "ui-images": "/ui-images/static-2.1138",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2835",
      "foundations-theming-base": "/foundations-theming-base/static-1.3337",
      "stylex": "/stylex/static-1.31",
      "HubStyle": "/HubStyle/static-2.11705",
      "sassPrefix": "/sassPrefix/static-1.154",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3793",
      "property-translator": "/property-translator/static-1.5339",
      "react-dnd-compat": "/react-dnd-compat/static-1.4556",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.8770",
      "audio-components": "/audio-components/static-1.5814",
      "cropperjs": "/cropperjs/static-1.10",
      "feedback-loader": "/feedback-loader/static-1.29177",
      "file-manager-components": "/file-manager-components/static-1.23421",
      "FileManagerImages": "/FileManagerImages/static-1.36572",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.827",
      "immerable": "/immerable/static-1.4090",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "ui-universal-auth": "/ui-universal-auth/static-1.8894",
      "urlinator": "/urlinator/static-1.4468",
      "video-components": "/video-components/static-1.13051",
      "video-data-lib": "/video-data-lib/static-1.34706",
      "video-embed": "/video-embed/static-1.35540",
      "redux-thunk": "/redux-thunk/static-2.43",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.274",
      "chirp-fetch": "/chirp-fetch/static-1.1820",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9810",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9808",
      "history": "/history/static-4.47",
      "react-router-dom": "/react-router-dom/static-5.26",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4959",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "autolinker": "/autolinker/static-3.11",
      "chatspot-core": "/chatspot-core/static-1.20970",
      "ContentUtils": "/ContentUtils/static-1.68158",
      "copilot-toolkit": "/copilot-toolkit/static-1.10944",
      "sanitize": "/sanitize/static-1.4409",
      "sanitize-text": "/sanitize-text/static-1.8081",
      "content-assistance-lib": "/content-assistance-lib/static-1.7650",
      "usage-tracker": "/usage-tracker/static-1.7273",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8989",
      "video-components-external": "/video-components-external/static-1.11048",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.689",
      "content-icons-ui": "/content-icons-ui/static-1.2211",
      "social-insights-client-types": "/social-insights-client-types/static-1.21881",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
      "outpost": "/outpost/static-1.4126",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4747",
      "integrations-lib": "/integrations-lib/static-1.15893",
      "underscore": "/underscore/static-1.8",
      "magpie-lib": "/magpie-lib/static-1.5519",
      "magpie-types": "/magpie-types/static-1.4979",
      "simple-logging-lib": "/simple-logging-lib/static-1.2987",
      "superstore": "/superstore/static-1.4705",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8634",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.28352",
      "navigation-messaging": "/navigation-messaging/static-1.7127",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12027",
      "content-media-compositions": "/content-media-compositions/static-2.16034",
      "idb-keyval": "/idb-keyval/static-1.42",
      "media-bridge-lib": "/media-bridge-lib/static-1.18810",
      "fsm": "/fsm/static-1.3671",
      "flux-actions": "/flux-actions/static-1.329",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7863",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13308",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5534",
      "laboratory-lib": "/laboratory-lib/static-3.7095",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7722",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.10310",
      "rxjs": "/rxjs/static-5.10",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.11087",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.10085",
      "unified-auth": "/unified-auth/static-1.408",
      "reactive-lib": "/reactive-lib/static-1.659",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6520",
      "js-cookie": "/js-cookie/static-1.18",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2946",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5285",
      "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.36",
      "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.136",
      "react-dlb": "/react-dlb/static-1.77",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3562",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6813",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9035",
      "batch-promise": "/batch-promise/static-1.1489",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3748",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4094",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3961",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6718",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3542",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3643",
      "persist-promise": "/persist-promise/static-1.3646"
    },
    "bundlingPackage": "conversations-embed",
    "bundlingPackageVersion": "static-1.26458",
    "project": "conversations-embed",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};